/**
 * Utility functions for markdown and text processing
 */

/**
 * Converts HTTPS links to anchor tags
 * @param {string} text - Text containing links
 * @returns {string} - Text with links converted to anchor tags
 */
export function convertHttpsLinksToAnchors(text) {
  // Regular expression to match links that start with "https" and end with "htm" or "html"
  const linkRegex = /https:\/\/[\w\-._~:/?#[\]@!$&'()*+,;=]*\.htm[l]?/g;

  // Replace matched links with anchor tags
  return text.replace(linkRegex, function (match) {
    return `<a href="${match}" target="_blank" rel="noopener noreferrer">${match}</a>`;
  });
}

/**
 * Converts markdown syntax to HTML
 * @param {string} markdown - Markdown text
 * @returns {string} - HTML string
 */
export function markdownToHTML(markdown) {
  // Replace Markdown headers (h1 - h6)
  markdown = markdown.replace(/(#+)(.*)/g, function (match, hashes, text) {
    var level = hashes.length;
    return "<h" + level + ">" + text.trim() + "</h" + level + ">";
  });

  // Replace Markdown bold (**text** or __text__)
  markdown = markdown.replace(
    /\*\*(.*?)\*\*|__(.*?)__/g,
    "<strong>$1$2</strong>"
  );

  // Replace Markdown italic (*text* or _text_)
  markdown = markdown.replace(/\*(.*?)\*|_(.*?)_/g, "<em>$1$2</em>");

  // Replace Markdown inline code (`code`)
  markdown = markdown.replace(/`(.*?)`/g, "<code>$1</code>");

  // Replace Markdown links ([text](url))
  markdown = markdown.replace(
    /\[([^[]+)\]\(([^)]+)\)/g,
    '<a href="$2">$1</a>'
  );

  // Replace Markdown images (![alt text](image url))
  markdown = markdown.replace(
    /!\[([^[]*)\]\(([^)]+)\)/g,
    '<img src="$2" alt="$1">'
  );

  // Replace Markdown line breaks (two spaces at the end of a line)
  markdown = markdown.replace(/ {2}\n/g, "<br />\n");

  return convertHttpsLinksToAnchors(markdown);
}

